<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-play-circle-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm-4.94 10.304l16 10a2 2 0 010 3.392l-16 10C17.728 36.529 16 35.571 16 34V14c0-1.57 1.728-2.529 3.06-1.696zm.94 5.304v12.784L30.226 24 20 17.608z"/></svg>
</template>
<script>

export default {
  name: 'IconPlayCircleFill',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
